import { Injectable, inject } from '@angular/core';
import { PlatformService } from 'ngx-unificator/services';
import { ReplaySubject } from 'rxjs';

const MOBILE_MAX_WIDTH = 767.98;
const SMALL_MOBILE_MAX_WIDTH = 375;
const TABLET_MAX_WIDTH = 991.98;
const SMALL_DESKTOP_MAX_WIDTH = 1199.98;

@Injectable({
  providedIn: 'root'
})

export class BreakpointsDetectorService {

  private _platform = inject(PlatformService);

  private _windowWidth: any = this._platform.isBrowser ? window.innerWidth : null;
  private _isMobile = false;
  private _isSmallMobile = false;
  private _isTablet = false;
  private _isSmallDesktop = false;
  private _isDesktop = false;

  private _belowDesktop = false;
  private _belowSmallDesktop = false;
  private _belowTablet = false;

  public updatedBreakpoints$: ReplaySubject<boolean> = new ReplaySubject<boolean>();

  /**
   * Screen lass then MOBILE_MAX_WIDTH
   */
  public get isMobile(): boolean {
    return this._isMobile;
  }

  /**
   * Screen lass then MOBILE_MAX_WIDTH
   */
  public get isSmallMobile(): boolean {
    return this._isSmallMobile;
  }

  /**
   * Screen lass then TABLET_MAX_WIDTH and more then MOBILE_MAX_WIDTH
   */
  public get isTablet(): boolean {
    return this._isTablet;
  }

  /**
   * Screen lass then SMALL_DESKTOP_MAX_WIDTH and more then TABLET_MAX_WIDTH
   */
  public get isSmallDesktop(): boolean {
    return this._isSmallDesktop;
  }

  /**
   * Screen grater then SMALL_DESKTOP_MAX_WIDTH
   */
  public get isDesktop(): boolean {
    return this._isDesktop;
  }

  /**
   * Screen lass then SMALL_DESKTOP_MAX_WIDTH
   */
  public get belowDesktop(): boolean {
    return this._belowDesktop;
  }

  /**
   * Screen lass then TABLET_MAX_WIDTH
   */
  public get belowSmallDesktop(): boolean {
    return this._belowSmallDesktop;
  }

  /**
   * Screen lass then MOBILE_MAX_WIDTH
   */
  public get belowTablet(): boolean {
    return this._belowTablet;
  }

  public initBreakpointsDetector() {
    this._handleResize();
    this._updateBreakpoints();
  }

  /**
   * Handle window resize event
   *
   * @private
   */
  private _handleResize() {
    if (this._platform.isBrowser) {
      this._windowWidth = window.innerWidth;
      this._updateBreakpoints();
    }
  }

  /**
   * Update breakpoint values
   *
   * @private
   */
  private _updateBreakpoints() {
    this._isMobile = this._windowWidth <= MOBILE_MAX_WIDTH;
    this._isSmallMobile = this._windowWidth <= SMALL_MOBILE_MAX_WIDTH;
    this._isTablet = this._windowWidth <= TABLET_MAX_WIDTH && this._windowWidth > MOBILE_MAX_WIDTH;
    this._isSmallDesktop = this._windowWidth <= SMALL_DESKTOP_MAX_WIDTH && this._windowWidth > TABLET_MAX_WIDTH;
    this._isDesktop = this._windowWidth > SMALL_DESKTOP_MAX_WIDTH;

    this._belowDesktop = this._windowWidth <= SMALL_DESKTOP_MAX_WIDTH;
    this._belowSmallDesktop = this._windowWidth <= TABLET_MAX_WIDTH;
    this._belowTablet = this._windowWidth <= MOBILE_MAX_WIDTH;
    this.updatedBreakpoints$.next(true);
  }
}
